export const isOnGoingDiscount = false; // If the discount is ON-GOING DISCOUNT, this should be true. If it is a ON-SALE DISCOUNT, this should be FALSE.

const MAX_DISCOUNT_AMOUNT = isOnGoingDiscount ? 15 : 10;
const LEVEL_1_START = isOnGoingDiscount ? 1 : 1;
const LEVEL_2_START = isOnGoingDiscount ? 20 : 20;
const LEVEL_3_START = isOnGoingDiscount ? 38 : 38;
const LEVEL_1_AMOUNT = isOnGoingDiscount ? 0.3 : 0.2;
const LEVEL_2_AMOUNT = isOnGoingDiscount ? 0.2 : 0.1;
const LEVEL_3_AMOUNT = isOnGoingDiscount ? 0.1 : 0.1;
const UPPER_LIMIT = isOnGoingDiscount ? 95 : 82;

function getDiscountAmountFromScore(score: number) {
  if (score >= UPPER_LIMIT) {
    return MAX_DISCOUNT_AMOUNT;
  }
  if (score >= LEVEL_3_START) {
    return (
      (score - LEVEL_3_START) * LEVEL_3_AMOUNT +
      (LEVEL_3_START - LEVEL_2_START) * LEVEL_2_AMOUNT +
      (LEVEL_2_START - LEVEL_1_START) * LEVEL_1_AMOUNT
    );
  } else if (score >= LEVEL_2_START) {
    return (
      (score - LEVEL_2_START) * LEVEL_2_AMOUNT + (LEVEL_2_START - LEVEL_1_START) * LEVEL_1_AMOUNT
    );
  } else if (score >= LEVEL_1_START) {
    return (score - LEVEL_1_START) * LEVEL_1_AMOUNT;
  } else {
    return 0;
  }
}

export const getDiscountAmount = (gameScore: number): number => {
  if (gameScore <= 0) {
    return 0;
  }

  let discountAmount = getDiscountAmountFromScore(gameScore);

  // This is redundant, we do it for safety
  discountAmount = Math.min(discountAmount, MAX_DISCOUNT_AMOUNT);

  return Math.round(discountAmount * 100) / 100;
};
